import React from 'react';
import CabCrudPage from './CabCrudPage';
import { uploadAdminAsset } from '../../../api/cabsHomepageAdmin';

const AdminCabsPromoVideos = () => (
  <CabCrudPage
    title="Promo Videos"
    description="Manage promotional videos for the cabs homepage."
    resource="promo-videos"
    uploadHandler={uploadAdminAsset}
    enableReorder
    defaultItem={{
      title: '',
      videoType: 'YOUTUBE',
      videoUrl: '',
      thumbnailUrl: '',
      caption: '',
      sortOrder: 0,
      isActive: true,
    }}
    columns={[
      { key: 'title', label: 'Title' },
      { key: 'videoType', label: 'Type' },
      { key: 'sortOrder', label: 'Sort' },
    ]}
    fields={[
      { name: 'title', label: 'Title', required: true },
      {
        name: 'videoType',
        label: 'Video type',
        type: 'select',
        options: [
          { value: 'YOUTUBE', label: 'YouTube' },
          { value: 'VIMEO', label: 'Vimeo' },
          { value: 'MP4', label: 'MP4' },
        ],
      },
      { name: 'videoUrl', label: 'Video URL', required: true, col: 'col-12' },
      { name: 'thumbnailUrl', label: 'Thumbnail image', type: 'image', required: true },
      { name: 'caption', label: 'Caption', type: 'textarea', rows: 3 },
      { name: 'sortOrder', label: 'Sort order', type: 'number' },
      { name: 'isActive', label: 'Active', type: 'checkbox', col: 'col-md-6' },
    ]}
  />
);

export default AdminCabsPromoVideos;
